import Vue from 'vue'
import Router from 'vue-router'
import Index from '../pages/index'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Index,
      redirect: '/home',
      children: [
        {
          path: '/information/category/:lang',
          name: 'information/category',
          component: () => import('../pages/information/category')
        },
        {
          path: '/information/:lang',
          name: 'information',
          component: () => import('../pages/information/index')
        },
        {
          path: '/information/store/:lang',
          name: 'information/store',
          component: () => import('../pages/information/store')
        },
        {
          path: '/activity',
          name: 'activity',
          component: () => import('../pages/activity')
        },
        {
          path: '/banner/:lang',
          name: 'banner',
          component: () => import('../pages/banner')
        },
        {
          path: '/game/:lang',
          name: 'game',
          component: () => import('../pages/game')
        },
        {
          path: '/game/channel/:lang',
          name: 'game/link',
          component: () => import('../pages/game/link')
        },
        {
          path: '/channel/:lang',
          name: 'channel',
          component: () => import('../pages/channel')
        },
        {
          path: '/goods/:lang',
          name: 'goods',
          component: () => import('../pages/goods')
        },
        {
          path: '/goods/limitedRecharge/:lang',
          name: 'goods/limitedRecharge',
          component: () => import('../pages/goods/LimitedRecharge.vue')
        },
        {
          path: '/goods/category/:lang',
          name: 'goods/category',
          component: () => import('../pages/goods/category')
        },
        {
          path: '/goodsRules',
          name: 'goodsRules',
          component: () => import('../pages/goods/rules')
        },
        {
          path: '/goodsRules/edit',
          name: 'goods.rule.edit',
          component: () => import('../pages/goods/ruleForm')
        },
        {
          path: '/setGoodsRules',
          name: 'setGoodsRules',
          component: () => import('../pages/goods/setRules')
        },
        {
          path: '/home',
          name: 'home',
          component: () => import('../pages/home')
        },
        {
          path: '/integral',
          name: 'integral',
          component: () => import('../pages/integral')
        },
        {
          path: '/large_pay',
          name: 'large_pay',
          component: () => import('../pages/large_pay')
        },
        {
          path: '/largeOrder',
          name: 'largeOrder',
          component: () => import('../pages/largeOrder')
        },
        {
          path: '/largePackage',
          name: 'largePackage',
          component: () => import('../pages/largePackages')
        },
        {
          path: '/packages',
          name: 'packages',
          component: () => import('../pages/packages')
        },
        {
          path: '/packages_record',
          name: 'packages_record',
          component: () => import('../pages/record')
        },
        {
          path: '/partner/game',
          name: 'partner/game',
          component: () => import('../pages/partner/game')
        },
        {
          path: '/partner/game/channel',
          name: 'partner/game/channel',
          component: () => import('../pages/partner/game/link')
        },
        {
          path: '/partner/banner',
          name: 'partner/banner',
          component: () => import('../pages/partner/banner')
        },
        {
          path: '/payChannel/:lang',
          name: 'payChannel',
          component: () => import('../pages/payChannel')
        },
        {
          path: '/personnel',
          name: 'personnel',
          component: () => import('../pages/personnel')
        },
        {
          path: '/role',
          name: 'role',
          component: () => import('../pages/role')
        },
        {
          path: '/menu',
          name: 'menu',
          component: () => import('../pages/menu')
        },
        {
          path: '/terms/:lang',
          name: '/terms',
          component: () => import('../pages/terms')
        },
        {
          path: '/user',
          name: 'user',
          component: () => import('../pages/user')
        },
        {
          path: '/cpApiDebug/:gameId',
          name: 'cpApiDebug',
          component: () => import('../pages/cpApiDebug')
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../pages/login')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js